import React, { useEffect, useState } from 'react';
import './Inquiry.css';
import Sidebar from '../Sidebar/Sidebar';
import AdminNavbar from '../AdminNavbar/AdminNavbar';
import ReplyModal from './ReplyModal';
const apiUrl = process.env.REACT_APP_API_BASE_URL;


function Inquiry() {
    const [inquiryData, setInquiryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null); 


    const [studentsCount, setStudentsCount] = useState(0);
    const [mentorsCount, setMentorsCount] = useState(0);
    const [coursesCount, setCoursesCount] = useState(0);

    useEffect(() => {
        fetch(`${apiUrl}/api/auth/applications`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch inquiries");
                }
                return response.json();
            })
            .then((data) => {
                setInquiryData(data.applications.reverse()); 
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });


            fetch("")
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to fetch stats");
                }
                return response.json();
            })
            .then(stats => {
                setStudentsCount(stats.students);
                setMentorsCount(stats.mentors);
                setCoursesCount(stats.courses);
            })
            .catch(error => console.error("Error fetching stats:", error));
    }, []);
    

    const handleReplyClick = (user) => {
        setSelectedUser(user);
    };

   


    return (
        <>
            <div className="main-dashboard">
            <div> <Sidebar /></div>
               
                <div className="dashboard">
                    <AdminNavbar />
                    <div className="content">
                        <div className="main-content">
                            <div className="info-cards">
                                <div className="info-card course-card">
                                    <div className="card-text">
                                        <h3>Certified Online Courses For Students</h3>
                                        <div className="certificate-icons">
                                            <span className="certificate-icon">🏆</span>
                                            <span className="certificate-icon">📜</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{coursesCount}+</h3>
                                        <p>Courses</p>
                                    </div>
                                    <div className="card-icon purple">
                                        <span>📚</span>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{studentsCount}+</h3>
                                        <p>Students</p>
                                    </div>
                                    <div className="card-icon blue">
                                        <span>👨‍🎓</span>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="card-content">
                                        <h3>{mentorsCount}+</h3>
                                        <p>Mentors</p>
                                    </div>
                                    <div className="card-icon purple">
                                        <span>👨‍🏫</span>
                                    </div>
                                </div>
                            </div>

                            <div className="tables-containerr">
                                <div className="inquiry-tablee">
                                    <h3>Inquiry</h3>

                                    {loading ? (
                                        <p>Loading inquiries...</p>
                                    ) : error ? (
                                        <p style={{ color: "red" }}>Error: {error}</p>
                                    ) : (
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Contact No</th>
                                                    <th>Remark</th>
                                                    <th>Interest</th>
                                                    <th>Education</th>
                                                    <th>CV</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {inquiryData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8">No inquiries found.</td>
                                                    </tr>
                                                ) : (
                                                    inquiryData.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>{row.name}</td>
                                                            <td>{row.email}</td>
                                                            <td>{row.contactNumber}</td>
                                                            <td>{row.remark}</td>
                                                            <td>{row.interest}</td>
                                                            <td>{row.education}</td>
                                                            <td>
                                                                {row.cv ? (
                                                                    <a
                                                                        href={`https://coderwing1.onrender.com/${row.cv}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        View CV
                                                                    </a>
                                                                ) : (
                                                                    "Not Uploaded"
                                                                )}
                                                            </td>
                                                            <td>
                                                            <button className="reply-btn" onClick={() => handleReplyClick(row)}>
                                                                    Reply
                                                                </button>                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedUser && <ReplyModal user={selectedUser} onClose={() => setSelectedUser(null)} />}

        </>
    );
}

export default Inquiry;
